import {
	AutoComplete,
	Col,
	Form,
	Input,
	Modal,
	Row,
	Select,
	Tooltip,
	message,
} from 'antd';
import getSymbolFromCurrency from 'currency-symbol-map';
import gql from 'graphql-tag';
import get from 'lodash/get';
import { useEffect, useState } from 'react';
import ProgressButton from 'react-progress-button';
import { queryContactsByUserIdIndex } from 'src/_shared/api/graphql/custom/contacts/';
import {
	lowerCase,
	sanitize,
	searchOpenSearchNetwork,
	uploadToS3,
	upperCase,
	validEmail,
} from 'src/_shared/services/utils.js';
import * as ModalStyles from './referralModalStyles.js';

const AutoCompleteOption = AutoComplete.Option;

const ReferralModal = (props) => {
	const [form] = Form.useForm();
	const [state, setState] = useState({
		autoCompleteResult: [],
		isSubmitting: false,
		isSubmitDisabled: false,
		newContact: true,
		error: false,
		buttonState: 'disabled',
		filename: null,
		filetype: null,
		errors: [],
		originalFile: [],
		selectedEmployee: '',
		selectedContact: '',
		autoCompleteContactResult: [],
		isSearchContact: false,
		selectedCandidate: {},
		selectedCandidateEmailOrPhone: '',
		visibleCandidate: false,
		isNewContact: false,
		searchQuery: '',
		loading: false,
		searchedEmployees: [],
		allUsers: [],
		currencyRate: 1,
		currencySymbol: '$',
		filteredDepartments: [],
		filteredRoles: [],
	});

	let timer;
	let uploadInput;

	useEffect(() => {
		const initializeComponent = async () => {
			await getCurrencyRate(get(props, 'currentUser.currency', 'USD'));
			await setQueryToState(get(state, 'searchQuery', ''), 0);

			if (props.matchFound) {
				setState((prev) => ({
					...prev,
					autoCompleteResult: [props.matchFound],
				}));
			}

			if (props.contact) {
				setState((prev) => ({ ...prev, autoCompleteResult: [props.contact] }));
			}

			if (props.contacts) {
				setState((prev) => ({
					...prev,
					autoCompleteContactResult: props.contacts,
				}));
			}
		};

		initializeComponent();
	}, []);

	const onChangeContact = async (value) => {
		const { contacts } = props;
		let autoCompleteContactResult = [];
		let isNewContact = true;

		setState((prev) => ({
			...prev,
			isSearchContact: false,
		}));

		if (value && value.length > 0) {
			setState((prev) => ({
				...prev,
				isSearchContact: true,
			}));

			autoCompleteContactResult = contacts.filter((x) => {
				if (
					lowerCase(get(x, 'firstName')).includes(lowerCase(value)) ||
					lowerCase(get(x, 'lastName')).includes(lowerCase(value))
				) {
					isNewContact = false;
					return x;
				}

				isNewContact = true;
			});
			setState((prev) => ({
				...prev,
				autoCompleteContactResult,
				isNewContact,
			}));
		}
	};

	const onChangeEmployee = (value) => {
		setState((prev) => ({
			...prev,
			selectedEmployee: {
				id: value.key,
				name: value.label,
			},
		}));
	};

	const onDelete = () => {
		setState((prev) => ({
			...prev,
			originalFile: [],
			filename: null,
			filetype: null,
			errors: [],
		}));
	};

	const onFileInputChange = (e) => {
		if (e.target.files && e.target.files.length > 0) {
			const errors = [];
			const isDocOrDocsOrPdf =
				e.target.files[0].type === 'application/msword' ||
				e.target.files[0].type ===
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
				e.target.files[0].type === 'application/pdf';
			if (!isDocOrDocsOrPdf) {
				errors.push('You can only upload doc, docx, pdf files! ');
			}

			const isLt2M = e.target.files[0].size / 1024 / 1024 < 2;
			if (!isLt2M) {
				errors.push('File size must smaller than 2MB!');
			}

			if (errors.length > 0) {
				setState((prev) => ({
					...prev,
					filename: e.target.files[0].name,
					errors,
				}));
				return errors;
			}

			setState((prev) => ({
				...prev,
				filename: e.target.files[0].name,
				filetype: e.target.files[0].type,
				originalFile: e.target.files[0],
				errors: [],
			}));

			return isDocOrDocsOrPdf && isLt2M;
		}
	};

	const onselectContact = (id, contactProps) => {
		setState((prev) => ({ ...prev, isNewContact: false }));

		const { contacts } = props;
		const selected = contacts.find((x) => x.id === id);
		setState((prev) => ({
			...prev,
			selectedCandidate: selected,
		}));
		if (selected && selected.emailAddress) {
			form.setFieldsValue({
				firstName: selected.firstName,
				emailAddress: selected.emailAddress,
				lastName: selected.lastName,
			});
		}
	};

	const getCurrencyRate = async (currency) => {
		const response = await fetch(
			`https://api.exchangeratesapi.io/latest?base=USD&symbols=${currency}`
		);
		const result = await response.json();
		if (result.error) {
			setState((prev) => ({
				...prev,
				currencyRate: 1,
				currencySymbol: '$',
			}));
		} else {
			const rate = result.rates[currency].toFixed(5);
			const symbol = getSymbolFromCurrency(currency);
			setState((prev) => ({
				...prev,
				currencyRate: rate,
				currencySymbol: symbol,
			}));
		}
	};

	const setQueryToState = async (searchQuery = '', timeout = 800) => {
		const company = get(props, 'currentUser.company');
		const { filteredDepartments = [], filteredRoles = [] } = state;

		setState((prev) => ({ ...prev, searchQuery }));
		clearTimeout(timer);
		if (searchQuery === '' && filteredDepartments.length <= 0) {
			setState((prev) => ({
				...prev,
				loading: false,
				searchedEmployees: get(prev, 'allUsers', []),
			}));
		}

		setState((prev) => ({ ...prev, loading: true }));
		timer = setTimeout(async () => {
			const parameters = {
				query: searchQuery,
				size: 300,
				role: get(props, 'currentUser.role'),
				currentUser: get(props, 'currentUser.id'),
				filters: {
					companies: get(company, 'id'),
					departments: filteredDepartments,
					roles: filteredRoles,
				},
			};
			const response = await searchOpenSearchNetwork(parameters, 'erin-users');

			if (get(response, 'query') === searchQuery) {
				setState((prev) => ({
					...prev,
					loading: false,
					searchedEmployees: get(response, 'data', []),
				}));
			}
		}, timeout);
	};

	const handleAutoCompleteCustomValidator = (rule, value, callback) => {
		callback();
	};

	const handleContactChange = (value) => {
		let autoCompleteResult = [];
		if (value) {
			for (const record of props.contacts) {
				const { firstName, lastName, emailAddress } = record;
				const isFirstNameMatch =
					firstName && firstName.toLowerCase().includes(value.toLowerCase());
				const isLastNameMatch =
					lastName && lastName.toLowerCase().includes(value.toLowerCase());
				const isEmailMatch =
					emailAddress &&
					emailAddress.toLowerCase().includes(value.toLowerCase());

				if (isFirstNameMatch || isLastNameMatch || isEmailMatch) {
					autoCompleteResult.push(record);
				}
			}
		} else {
			autoCompleteResult = [];
		}

		setState((prev) => ({ ...prev, autoCompleteResult }));
	};

	const handleNewContact = () => {
		setState((prevState) => ({
			...prevState,
			newContact: !prevState.newContact,
		}));
	};

	const handleSubmit = async (values) => {
		const {
			currentUser,
			job,
			onCreateContact,
			onCreateReferral,
			onUpdateContact,
			client,
			toggleLoading,
		} = props;
		const { filename, isSubmitDisabled, isNewContact } = state;
		if (isSubmitDisabled) {
			return;
		}

		try {
			setState((prev) => ({
				...prev,
				buttonState: 'loading',
				isSubmitDisabled: true,
			}));
			toggleLoading();
			let email = null;
			let importMethod = '';
			let { emailAddress } = values;
			emailAddress &&= sanitize(emailAddress);
			let { firstName } = values;
			firstName &&= sanitize(firstName);
			let { lastName } = values;
			lastName &&= sanitize(lastName);
			if (emailAddress && validEmail(emailAddress)) {
				email = emailAddress;
				importMethod = 'email';
			}

			let { atsId } = values;
			atsId &&= sanitize(atsId);

			const d = new Date();
			const dformat = `${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

			const contactInput = {
				input: {
					firstName,
					lastName,
					socialMediaAccounts: null,
					userId: state.selectedEmployee.id,
					companyId: currentUser.companyId,
					jobHistory: null,
					importMethod,
					disableSmartReferrals: false,
					emailAddress: email.toLowerCase(),
				},
			};

			if (atsId) {
				contactInput.input.atsId = atsId;
			}

			const existingContact = await client
				.query({
					query: gql(queryContactsByUserIdIndex),
					variables: {
						userId: state.selectedEmployee.id,
					},
					fetchPolicy: 'network-only',
				})
				.then((result) => {
					return result.data.queryContactsByUserIdIndex.items.find(
						(contact) => contact.emailAddress === emailAddress
					);
				});
			// If contact already exists, then skip creating contact
			let newContactId = '';
			if (!existingContact) {
				const newContact = await onCreateContact(contactInput).then(
					(response) => response.data.createContact
				);
				newContactId = newContact.id;
			} else if (atsId) {
				contactInput.input.id = existingContact.id;
				const updatedContact = await onUpdateContact(contactInput).then(
					(response) => response.data.updateContact
				);
			}

			// Proceed creating referral for whether it was a new contact, or existing contact
			const referralInput = {
				input: {
					referralDate: new Date().toISOString(),
					companyId: currentUser.companyId,
					contactId: existingContact ? existingContact.id : newContactId,
					referralType: 'email',
					referralSource: 'direct',
					referralDevice: 'web',
					userId: state.selectedEmployee.id,
					jobId: get(job, ['id'], ''),
					status: 'accepted',
					note: null,
					message: null,
					referralSource: 'general',
					referralDevice: 'web',
					creationType: 'manual',
				},
			};
			if (atsId) {
				referralInput.input.ownershipAtsId = atsId;
			}

			const resume = {
				bucket: 'erin-documents',
				key: `resumes/${
					existingContact ? existingContact.id : newContactId
				}/${dformat + '-' + filename}`,
				region: 'us-east-2',
			};
			if (filename) referralInput.input.contactResume = resume;
			if (filename) {
				const updateContactResumeInput = {
					id: existingContact ? existingContact.id : newContactId,
					contactResume: resume,
				};
				await onUpdateContact({ input: updateContactResumeInput });
				await updateS3ContactResume(resume);
			}

			await onCreateReferral(referralInput);

			// Show success
			setState((prev) => ({ ...prev, buttonState: 'success' }));
			message.success('Your request is submitted.', 5);
			await new Promise((resolve) => {
				setTimeout(() => resolve(), 1000);
			});

			props.handleCancelAll();
			return props.updateReferrals(referralInput.input);
		} catch (error) {
			console.log(error, 'There was an error in handleSubmit ');
			setState((prev) => ({ ...prev, buttonState: 'error' }));

			await new Promise((resolve) => {
				setTimeout(() => resolve(), 2000);
			});
			setState((prev) => ({
				...prev,
				buttonState: '',
				isSubmitDisabled: false,
			}));
		}
	};

	const updateS3ContactResume = async (resume) => {
		const { filename, filetype, originalFile } = state;
		if (filename) {
			try {
				await uploadToS3(originalFile, resume.key, resume.bucket);
			} catch (error) {
				console.error(error);
			}
		}
	};

	const renderContact = () => {
		const {
			autoCompleteContactResult = [],
			isSearchContact,
			visibleCandidate,
		} = state;
		const contactOptions = [...autoCompleteContactResult]
			.sort((a, b) => {
				const aName = upperCase(get(a, 'firstName'));
				const bName = upperCase(get(b, 'firstName'));
				if (aName > bName) {
					return 1;
				}

				if (aName < bName) {
					return -1;
				}

				return 0;
			})
			.map((contact) => {
				const firstName = get(contact, 'firstName', '');
				const lastName = get(contact, 'lastName', '');
				const emailAddress = get(contact, 'emailAddress', '');
				const phoneNumber = get(contact, 'phoneNumber', '');
				let content = '';
				if (emailAddress) {
					content = `${firstName + ' ' + lastName + ' (' + emailAddress + ')'}`;
				} else if (phoneNumber) {
					content = `${firstName + ' ' + lastName + ' (' + phoneNumber + ')'}`;
				}

				return {
					key: contact.id,
					value: contact.id,
					label: `${firstName + ' ' + lastName}`,
					title: content,
				};
			});

		return (
			<Form.Item
				name="firstName"
				rules={[
					{
						required: true,
						message: (
							<Tooltip
								open={visibleCandidate}
								placement="topLeft"
								style={{ fontWeight: 1000 }}
								title="First Name"
							>
								<div
									style={{
										position: 'relative',
										top: -50,
										display: 'inline-block',
									}}
								/>
							</Tooltip>
						),
					},
					{
						validator: handleAutoCompleteCustomValidator,
					},
				]}
			>
				<AutoComplete
					options={isSearchContact ? contactOptions : []}
					className="custom-input custom-input-autocomplete"
					filterOption={false}
					placeholder="First Name"
					autoComplete="off"
					onSearch={onChangeContact}
					onSelect={onselectContact}
				/>
			</Form.Item>
		);
	};

	const renderEmployees = () => {
		const users = get(state, 'searchedEmployees', []);
		const { Option } = Select;
		const options = users
			.sort(function (a, b) {
				const nameA = a.firstName.toUpperCase(); // ignore upper and lowercase
				const nameB = b.firstName.toUpperCase(); // ignore upper and lowercase
				if (nameA < nameB) {
					return -1;
				}

				if (nameA > nameB) {
					return 1;
				}

				// Names must be equal
				return 0;
			})
			.map((emp) => (
				<Option key={emp.id}>
					{`${emp.firstName} ${emp.lastName} - ${emp.emailAddress}`}
				</Option>
			));
		return (
			<Select
				showSearch
				labelInValue
				className="custom-input"
				optionFilterProp="children"
				placeholder="Ex. James Smith"
				filterOption={(input, option) => {
					return option.props.children
						.toLowerCase()
						.includes(input.toLowerCase());
				}}
				onSelect={(value) => onChangeEmployee(value)}
				onSearch={async (value) => await setQueryToState(value, 500)}
			>
				{options}
			</Select>
		);
	};

	const {
		job,
		visible,
		handleCancel,
		referralInformationText,
		createReferralForText,
		positiontext,
		selectEmployeeText,
		enterReferralInformationText,
		lastNameText,
		emailText,
		clickHereText,
		attachResumeText,
		noteText,
		referralAutomaticallyAcceptedText,
		submitReferralText,
	} = props;
	const { buttonState, errors, filename } = state;

	return (
		<Modal
			centered
			open={visible}
			footer={null}
			width={600}
			title={referralInformationText}
			onCancel={handleCancel}
		>
			<Form form={form} onFinish={handleSubmit}>
				<p className="text-center small">
					{createReferralForText}{' '}
					<a
						href={`/jobs/${get(job, ['id'], '')}`}
						target="_blank"
						rel="noreferrer"
					>
						{get(job, 'title')}
					</a>{' '}
					{positiontext}.
				</p>
				<div className="custom-form-group">
					<label className="custom-label">{selectEmployeeText}</label>
					<Form.Item
						name="selectEmployee"
						rules={[
							{ required: true, message: 'Please select an Employee' },
							{
								validator: async (rule, value) => {
									if (value) {
										setState((prev) => ({ ...prev, buttonState: '' }));
									}
								},
							},
						]}
					>
						{renderEmployees()}
					</Form.Item>
				</div>
				<div className="custom-form-group">
					<h3 className="custom-label">{enterReferralInformationText}</h3>
					<Row type="flex" justify="space-between" gutter={12}>
						<Col xs={24} lg={12} className="mb-3">
							{renderContact()}
						</Col>
						<Col xs={24} lg={12} className="mb-3">
							<Form.Item
								name="lastName"
								rules={[{ required: true, message: 'Please input Last Name' }]}
							>
								<Input className="custom-input" placeholder={lastNameText} />
							</Form.Item>
						</Col>
						<Col xs={24} lg={12}>
							<Form.Item
								name="emailAddress"
								rules={[
									{ type: 'email', message: 'Enter a valid email.' },
									{
										required: true,
										message: 'Please enter an email address.',
									},
								]}
							>
								<Input className="custom-input" placeholder={emailText} />
							</Form.Item>
						</Col>
						<Col xs={24} lg={12}>
							<Form.Item
								name="atsId"
								rules={[
									{
										required: false,
									},
								]}
							>
								<Input className="custom-input" placeholder="Candidate ID" />
							</Form.Item>
						</Col>
					</Row>
				</div>
				{!filename && (
					<p className="upload-link-text">
						<label className="upload-link" htmlFor="resumeFile">
							{clickHereText}
							<input
								ref={(ref) => {
									uploadInput = ref;
								}}
								hidden
								type="file"
								accept=".doc,.docx,application/msword,.pdf,application/pdf"
								id="resumeFile"
								name="file"
								onClick={() => {
									setState((prev) => ({
										...prev,
										filename: null,
										filetype: null,
										originalFile: [],
									}));
									uploadInput = null;
								}}
								onChange={onFileInputChange}
							/>
						</label>
						{attachResumeText}
						<span className="label-optional">(optional)</span>
					</p>
				)}
				{filename && (
					<div className="upload-file-text">
						<p>
							{filename}

							<i className="icon-bin text-danger cursor-p" onClick={onDelete} />
						</p>
					</div>
				)}
				{errors && errors.length > 0 ? (
					<div className={ModalStyles.fieldErrors}>
						<span className={ModalStyles.errorText}> {errors} </span>
					</div>
				) : null}
				<p className="text-note mt-3">
					<strong>{noteText}:</strong> {referralAutomaticallyAcceptedText}.
				</p>
				<Form.Item className="modal-footer-btn">
					<ProgressButton
						controlled
						durationSuccess={3000}
						state={buttonState}
						type="submit"
					>
						{submitReferralText}
					</ProgressButton>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default ReferralModal;
